import React, { useState } from 'react';
import mailIcon from './../images/chat-line.svg';
import backIcon from '../images/close-line.svg';
import { useTranslation } from '../i18n';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const Feedback = () => {
  const { t } = useTranslation();
  const email = 'feedback@bookie.website';

  const [feedbackModalIsOpen, setFeedbackIsOpen] = useState(false);
  function openFeedbackModal() {
    setFeedbackIsOpen(true);
    logEvent(analytics, 'account_settings_feedback');
  }
  function closeFeedbackModal() {
    setFeedbackIsOpen(false);
  }

  return [
    <div className="row-item" key="feedback">
      <img height={24} width={24} alt="Feedback" src={mailIcon} />
      <div
        className="link"
        onClick={() => openFeedbackModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openFeedbackModal();
          }
        }}
        tabIndex={0}
      >
        {t.userfeedbacklink}
      </div>
    </div>,

    feedbackModalIsOpen && (
      <div className="dialog-content fullscreen-overlay" key="feedback-overlay">
        <div className="fullscreen-container" tabIndex={-1}>
          <button className={`fullscreen-close`} onClick={closeFeedbackModal}>
            <img src={backIcon} width={42} height={42} alt="Close icon" />
            {t.close}
          </button>

          <div className="card-wrapper">
            <div className="card">
              <h3>{t.feedbackheader}</h3>
              <div className="pt-65">{t.feedbackmessage}</div>
              <div className="pt-65">
                {t.feedbackaction}{' '}
                <a href={`mailto:${email}?subject=${t.feedbacksubject}`}>
                  {email}
                </a>
              </div>
            </div>
          </div>

          <div className="btn-group-wrapper">
            <div className="btn-group">
              <button
                className="btn btn-secondary w-100"
                onClick={() => closeFeedbackModal()}
              >
                {t.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
  ];
};

export default Feedback;
